<div class="service-history-container">
  <!-- TOP SECTION: Previous Services + Job Card Detail side by side -->
  <div class="components-header">
    <div class="panel-title">{{ 'bikeshop.workshop.jobcard.customer.previous_services' | translate }}</div>
  </div>
  <div class="top-section">

    <!-- Left: Service List -->
    <div class="service-list-panel">
      <!--<div class="panel-title">{{ 'bikeshop.workshop.jobcard.customer.previous_services' | translate }}</div>-->

      <div *ngIf="loading" class="loading-state">
        <p-progressSpinner [style]="{ width: '24px', height: '24px' }"
                           animationDuration=".5s"></p-progressSpinner>
      </div>

      <div *ngIf="!loading && serviceHistory.length === 0" class="empty-state">
        {{ 'bikeshop.modal.shared.bike.no_services' | translate }}
      </div>

      <div *ngFor="let service of serviceHistory"
           class="service-list-item"
           [class.service-list-item--selected]="selectedService?.id === service.id"
           (click)="selectService(service)">
        <div class="service-list-item__number">#{{ service.jobcardNo }}</div>
        <div class="service-list-item__date">
          {{ service.serviceDate | DateFormatPipe: displayDateTimeFormat }}
        </div>
        <div class="service-list-item__shop">{{ service.storeName }}</div>
      </div>
    </div>

    <!-- Right: Job Card Detail -->
    <div class="service-detail-panel">
      <ng-container *ngIf="selectedService">
        <!-- External shop notice -->
        <!--<div class="external-notice"
             *ngIf="selectedService.storeName">
          This job was serviced at {{ selectedService.storeName }}. View only.
        </div>-->

        <div class="service-detail-title">
          <a style="cursor:pointer" (click)="openJobCard(selectedService)">{{ 'bikeshop.inventory_audit.jobcard_no' | translate }} {{ selectedService.jobcardNo }}</a>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ 'bikeshop.roles.technician' | translate }}</span>
          <span class="detail-value">{{ selectedService.technician || '—' }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ 'bikeshop.menu.service_types' | translate}}</span>
          <span class="detail-value">{{ getServiceTypes(selectedService) || '—' }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">{{ 'bikeshop.modal.shedule_service.service_date' | translate }}</span>
          <span class="detail-value">
            {{ (selectedService.serviceDate | DateFormatPipe: displayDateTimeFormat) }}
          </span>
        </div>

        <!-- Internal Notes -->
        <ng-container *ngIf="selectedService.internalNotes">
          <div class="notes-section-title">{{ 'bikeshop.modal.update_job_card.job_card.internal_notes' | translate }}</div>
          <div class="notes-text">
            <span *ngIf="!isExpanded('internal')" innerHTML="{{ getNotePreview(selectedService.internalNotes) }}"></span>
            <span *ngIf="isExpanded('internal')" innerHTML="{{ selectedService.internalNotes }}"></span>
          </div>
          <span *ngIf="shouldTruncate(selectedService.internalNotes)" class="read-more-link"
                (click)="toggleNote('internal')">{{ isExpanded('internal') ? ('general.read_less' | translate) : 'general.read_more' | translate }}</span>
        </ng-container>

        <!-- External Notes -->
        <ng-container *ngIf="selectedService.externalNotes">
          <div class="notes-section-title">{{ 'bikeshop.modal.update_job_card.job_card.external_notes' | translate }}</div>
          <div class="notes-text">
            <span *ngIf="!isExpanded('external')" innerHTML="{{ getNotePreview(selectedService.externalNotes) }}"></span>
            <span *ngIf="isExpanded('external')" innerHTML="{{ selectedService.externalNotes }}"></span>
          </div>
          <span *ngIf="shouldTruncate(selectedService.externalNotes)" class="read-more-link"
                (click)="toggleNote('external')">{{ isExpanded('external') ? ('general.read_less' | translate) : 'general.read_more' | translate }}</span>
        </ng-container>

        <!-- Customer Notes -->
        <ng-container *ngIf="selectedService.customerNotes">
          <div class="notes-section-title">{{ 'bikeshop.modal.update_job_card.job_card.customer_notes' | translate }}</div>
          <div class="notes-text">
            <span *ngIf="!isExpanded('customer')" innerHTML="{{ getNotePreview(selectedService.customerNotes) }}"></span>
            <span *ngIf="isExpanded('customer')" innerHTML="{{ selectedService.customerNotes }}"></span>
          </div>
          <span *ngIf="shouldTruncate(selectedService.customerNotes)" class="read-more-link"
                (click)="toggleNote('customer')">{{ isExpanded('customer') ? ('general.read_less' | translate) : 'general.read_more' | translate }}</span>
        </ng-container>
      </ng-container>

      <!--<div *ngIf="!selectedService && !loading" class="empty-state">
        Select a service to view details.
      </div>-->
    </div>
  </div>

  <!-- BOTTOM SECTION: Bike Components -->
  <div class="components-header" *ngIf="partnerData.PartnerType === 1">
    <div class="panel-title">{{ 'bikeshop.modal.shared.bike.bike_components' | translate }}</div>
    <hub-button-icon-only [icon]="'plus'" *ngIf="!showAddGear"
                          [style]="'secondary'" (click)="addNewComponent()"></hub-button-icon-only>
    <hub-button-icon-only [icon]="'minus'" *ngIf="showAddGear"
                          [style]="'secondary'" (click)="addNewComponent()"></hub-button-icon-only>
  </div>
  <div class="components-section"  *ngIf="partnerData.PartnerType === 1">
    <!--<div class="components-header">
      <div class="panel-title">{{ 'bikeshop.modal.shared.bike.bike_components' | translate }}</div>
      <hub-button-icon-only [icon]="'plus'" *ngIf="!showAddGear"
                            [style]="'secondary'" (click)="addNewComponent()"></hub-button-icon-only>
      <hub-button-icon-only [icon]="'minus'" *ngIf="showAddGear"
                            [style]="'secondary'" (click)="addNewComponent()"></hub-button-icon-only>
    </div>-->

    <div class="components-grid"
         *ngIf="!showAddGear"
         #componentsGrid
         (mousedown)="onGridMouseDown($event, componentsGrid)"
         (mousemove)="onGridMouseMove($event, componentsGrid)"
         (mouseup)="onGridMouseUp()"
         (mouseleave)="onGridMouseUp()"
         [class.is-dragging]="isDraggingGrid">
      <div class="component-card" *ngFor="let component of components">
        <div class="component-card__header">
          <div class="component-card__name">
            {{ component.GearTypeName || component.manufacturer }}
          </div>
          <hub-button-icon-only [icon]="'pencil'" [style]="'borderless'" (click)="editComponent(component)"></hub-button-icon-only>
          <div class="component-card__date">
            {{ 'bikeshop.modal.component.date_added' | translate }}: {{ component.dateAdded | date: 'dd-MM-yyyy' }}
          </div>
        </div>
        <div class="component-card__category">
          {{ component.gearType || '' }}
        </div>
        <div class="component-card__manufacturer">
          {{ component.manufacturer || '' }}
        </div>
        <div class="component-card__model">{{ component.model || '' }}</div>

        <ng-container *ngIf="component.serviceInterval && component.serviceInterval > 0">
          <div class="component-card__indicator-label">{{ 'bikeshop.modal.component.service_indicator' | translate }}</div>
          <div class="component-card__indicator">
            <div class="indicator-bar">
              <div class="indicator-bar__fill"
                   [class]="getServiceIndicatorClass(getServiceIndicatorPercent(component))"
                   [style.width.%]="getServiceIndicatorPercent(component)"></div>
            </div>
            <div class="indicator-text">
              {{ getServiceIndicatorPercent(component) }}%
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="!loading && components.length === 0" class="empty-state">
        {{ 'bikeshop.modal.shared.bike.no_components' | translate }}
      </div>
    </div>
    <app-component-edit *ngIf="showAddGear" [gear]="gear" [distanceMetric]="distanceMetric" [closeModal]="false" (componentCreated)="getBikeGear()"></app-component-edit>
  </div>
</div>
